// source: xcommon/user.proto
/**
 * @fileoverview
 * @enhanceable
 * @suppress {missingRequire} reports error on implicit type usages.
 * @suppress {messageConventions} JS Compiler reports an error if a variable or
 *     field starts with 'MSG_' and isn't a translatable message.
 * @public
 */
// GENERATED CODE -- DO NOT EDIT!
/* eslint-disable */
// @ts-nocheck

var jspb = require('google-protobuf');
var goog = jspb;
var global =
    (typeof globalThis !== 'undefined' && globalThis) ||
    (typeof window !== 'undefined' && window) ||
    (typeof global !== 'undefined' && global) ||
    (typeof self !== 'undefined' && self) ||
    (function () { return this; }).call(null) ||
    Function('return this')();

var xcommon_common_pb = require('../xcommon/common_pb.js');
goog.object.extend(proto, xcommon_common_pb);
var xcommon_enum_pb = require('../xcommon/enum_pb.js');
goog.object.extend(proto, xcommon_enum_pb);
var xcommon_module_pb = require('../xcommon/module_pb.js');
goog.object.extend(proto, xcommon_module_pb);
goog.exportSymbol('proto.xcommon.CaptchaReq', null, global);
goog.exportSymbol('proto.xcommon.CaptchaResp', null, global);
goog.exportSymbol('proto.xcommon.LoginInfo', null, global);
goog.exportSymbol('proto.xcommon.LoginSuccessData', null, global);
goog.exportSymbol('proto.xcommon.Menu', null, global);
goog.exportSymbol('proto.xcommon.UserCommon', null, global);
goog.exportSymbol('proto.xcommon.UserInfo', null, global);
goog.exportSymbol('proto.xcommon.UserInfoMini', null, global);
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.xcommon.LoginSuccessData = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, proto.xcommon.LoginSuccessData.repeatedFields_, null);
};
goog.inherits(proto.xcommon.LoginSuccessData, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.xcommon.LoginSuccessData.displayName = 'proto.xcommon.LoginSuccessData';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.xcommon.Menu = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, proto.xcommon.Menu.repeatedFields_, null);
};
goog.inherits(proto.xcommon.Menu, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.xcommon.Menu.displayName = 'proto.xcommon.Menu';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.xcommon.UserInfo = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.xcommon.UserInfo, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.xcommon.UserInfo.displayName = 'proto.xcommon.UserInfo';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.xcommon.UserInfoMini = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.xcommon.UserInfoMini, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.xcommon.UserInfoMini.displayName = 'proto.xcommon.UserInfoMini';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.xcommon.UserCommon = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.xcommon.UserCommon, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.xcommon.UserCommon.displayName = 'proto.xcommon.UserCommon';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.xcommon.LoginInfo = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.xcommon.LoginInfo, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.xcommon.LoginInfo.displayName = 'proto.xcommon.LoginInfo';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.xcommon.CaptchaReq = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.xcommon.CaptchaReq, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.xcommon.CaptchaReq.displayName = 'proto.xcommon.CaptchaReq';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.xcommon.CaptchaResp = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.xcommon.CaptchaResp, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.xcommon.CaptchaResp.displayName = 'proto.xcommon.CaptchaResp';
}

/**
 * List of repeated fields within this message type.
 * @private {!Array<number>}
 * @const
 */
proto.xcommon.LoginSuccessData.repeatedFields_ = [3];



if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.xcommon.LoginSuccessData.prototype.toObject = function(opt_includeInstance) {
  return proto.xcommon.LoginSuccessData.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.xcommon.LoginSuccessData} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.xcommon.LoginSuccessData.toObject = function(includeInstance, msg) {
  var f, obj = {
    token: jspb.Message.getFieldWithDefault(msg, 1, ""),
    userid: jspb.Message.getFieldWithDefault(msg, 2, 0),
    menuList: jspb.Message.toObjectList(msg.getMenuList(),
    proto.xcommon.Menu.toObject, includeInstance),
    name: jspb.Message.getFieldWithDefault(msg, 4, ""),
    systeminfo: jspb.Message.getFieldWithDefault(msg, 5, ""),
    usergroupid: jspb.Message.getFieldWithDefault(msg, 6, 0),
    exectype: jspb.Message.getFieldWithDefault(msg, 7, 0)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.xcommon.LoginSuccessData}
 */
proto.xcommon.LoginSuccessData.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.xcommon.LoginSuccessData;
  return proto.xcommon.LoginSuccessData.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.xcommon.LoginSuccessData} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.xcommon.LoginSuccessData}
 */
proto.xcommon.LoginSuccessData.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {string} */ (reader.readString());
      msg.setToken(value);
      break;
    case 2:
      var value = /** @type {number} */ (reader.readInt64());
      msg.setUserid(value);
      break;
    case 3:
      var value = new proto.xcommon.Menu;
      reader.readMessage(value,proto.xcommon.Menu.deserializeBinaryFromReader);
      msg.addMenu(value);
      break;
    case 4:
      var value = /** @type {string} */ (reader.readString());
      msg.setName(value);
      break;
    case 5:
      var value = /** @type {string} */ (reader.readString());
      msg.setSysteminfo(value);
      break;
    case 6:
      var value = /** @type {number} */ (reader.readInt64());
      msg.setUsergroupid(value);
      break;
    case 7:
      var value = /** @type {!proto.xcommon.ExecType} */ (reader.readEnum());
      msg.setExectype(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.xcommon.LoginSuccessData.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.xcommon.LoginSuccessData.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.xcommon.LoginSuccessData} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.xcommon.LoginSuccessData.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getToken();
  if (f.length > 0) {
    writer.writeString(
      1,
      f
    );
  }
  f = message.getUserid();
  if (f !== 0) {
    writer.writeInt64(
      2,
      f
    );
  }
  f = message.getMenuList();
  if (f.length > 0) {
    writer.writeRepeatedMessage(
      3,
      f,
      proto.xcommon.Menu.serializeBinaryToWriter
    );
  }
  f = message.getName();
  if (f.length > 0) {
    writer.writeString(
      4,
      f
    );
  }
  f = message.getSysteminfo();
  if (f.length > 0) {
    writer.writeString(
      5,
      f
    );
  }
  f = message.getUsergroupid();
  if (f !== 0) {
    writer.writeInt64(
      6,
      f
    );
  }
  f = message.getExectype();
  if (f !== 0.0) {
    writer.writeEnum(
      7,
      f
    );
  }
};


/**
 * optional string Token = 1;
 * @return {string}
 */
proto.xcommon.LoginSuccessData.prototype.getToken = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 1, ""));
};


/**
 * @param {string} value
 * @return {!proto.xcommon.LoginSuccessData} returns this
 */
proto.xcommon.LoginSuccessData.prototype.setToken = function(value) {
  return jspb.Message.setProto3StringField(this, 1, value);
};


/**
 * optional int64 UserId = 2;
 * @return {number}
 */
proto.xcommon.LoginSuccessData.prototype.getUserid = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 2, 0));
};


/**
 * @param {number} value
 * @return {!proto.xcommon.LoginSuccessData} returns this
 */
proto.xcommon.LoginSuccessData.prototype.setUserid = function(value) {
  return jspb.Message.setProto3IntField(this, 2, value);
};


/**
 * repeated Menu Menu = 3;
 * @return {!Array<!proto.xcommon.Menu>}
 */
proto.xcommon.LoginSuccessData.prototype.getMenuList = function() {
  return /** @type{!Array<!proto.xcommon.Menu>} */ (
    jspb.Message.getRepeatedWrapperField(this, proto.xcommon.Menu, 3));
};


/**
 * @param {!Array<!proto.xcommon.Menu>} value
 * @return {!proto.xcommon.LoginSuccessData} returns this
*/
proto.xcommon.LoginSuccessData.prototype.setMenuList = function(value) {
  return jspb.Message.setRepeatedWrapperField(this, 3, value);
};


/**
 * @param {!proto.xcommon.Menu=} opt_value
 * @param {number=} opt_index
 * @return {!proto.xcommon.Menu}
 */
proto.xcommon.LoginSuccessData.prototype.addMenu = function(opt_value, opt_index) {
  return jspb.Message.addToRepeatedWrapperField(this, 3, opt_value, proto.xcommon.Menu, opt_index);
};


/**
 * Clears the list making it empty but non-null.
 * @return {!proto.xcommon.LoginSuccessData} returns this
 */
proto.xcommon.LoginSuccessData.prototype.clearMenuList = function() {
  return this.setMenuList([]);
};


/**
 * optional string Name = 4;
 * @return {string}
 */
proto.xcommon.LoginSuccessData.prototype.getName = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 4, ""));
};


/**
 * @param {string} value
 * @return {!proto.xcommon.LoginSuccessData} returns this
 */
proto.xcommon.LoginSuccessData.prototype.setName = function(value) {
  return jspb.Message.setProto3StringField(this, 4, value);
};


/**
 * optional string SystemInfo = 5;
 * @return {string}
 */
proto.xcommon.LoginSuccessData.prototype.getSysteminfo = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 5, ""));
};


/**
 * @param {string} value
 * @return {!proto.xcommon.LoginSuccessData} returns this
 */
proto.xcommon.LoginSuccessData.prototype.setSysteminfo = function(value) {
  return jspb.Message.setProto3StringField(this, 5, value);
};


/**
 * optional int64 UserGroupID = 6;
 * @return {number}
 */
proto.xcommon.LoginSuccessData.prototype.getUsergroupid = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 6, 0));
};


/**
 * @param {number} value
 * @return {!proto.xcommon.LoginSuccessData} returns this
 */
proto.xcommon.LoginSuccessData.prototype.setUsergroupid = function(value) {
  return jspb.Message.setProto3IntField(this, 6, value);
};


/**
 * optional ExecType ExecType = 7;
 * @return {!proto.xcommon.ExecType}
 */
proto.xcommon.LoginSuccessData.prototype.getExectype = function() {
  return /** @type {!proto.xcommon.ExecType} */ (jspb.Message.getFieldWithDefault(this, 7, 0));
};


/**
 * @param {!proto.xcommon.ExecType} value
 * @return {!proto.xcommon.LoginSuccessData} returns this
 */
proto.xcommon.LoginSuccessData.prototype.setExectype = function(value) {
  return jspb.Message.setProto3EnumField(this, 7, value);
};



/**
 * List of repeated fields within this message type.
 * @private {!Array<number>}
 * @const
 */
proto.xcommon.Menu.repeatedFields_ = [5];



if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.xcommon.Menu.prototype.toObject = function(opt_includeInstance) {
  return proto.xcommon.Menu.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.xcommon.Menu} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.xcommon.Menu.toObject = function(includeInstance, msg) {
  var f, obj = {
    id: jspb.Message.getFieldWithDefault(msg, 1, 0),
    pid: jspb.Message.getFieldWithDefault(msg, 2, 0),
    name: jspb.Message.getFieldWithDefault(msg, 3, ""),
    route: jspb.Message.getFieldWithDefault(msg, 4, ""),
    submenuList: jspb.Message.toObjectList(msg.getSubmenuList(),
    proto.xcommon.Menu.toObject, includeInstance)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.xcommon.Menu}
 */
proto.xcommon.Menu.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.xcommon.Menu;
  return proto.xcommon.Menu.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.xcommon.Menu} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.xcommon.Menu}
 */
proto.xcommon.Menu.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {number} */ (reader.readInt64());
      msg.setId(value);
      break;
    case 2:
      var value = /** @type {number} */ (reader.readInt64());
      msg.setPid(value);
      break;
    case 3:
      var value = /** @type {string} */ (reader.readString());
      msg.setName(value);
      break;
    case 4:
      var value = /** @type {string} */ (reader.readString());
      msg.setRoute(value);
      break;
    case 5:
      var value = new proto.xcommon.Menu;
      reader.readMessage(value,proto.xcommon.Menu.deserializeBinaryFromReader);
      msg.addSubmenu(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.xcommon.Menu.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.xcommon.Menu.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.xcommon.Menu} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.xcommon.Menu.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getId();
  if (f !== 0) {
    writer.writeInt64(
      1,
      f
    );
  }
  f = message.getPid();
  if (f !== 0) {
    writer.writeInt64(
      2,
      f
    );
  }
  f = message.getName();
  if (f.length > 0) {
    writer.writeString(
      3,
      f
    );
  }
  f = message.getRoute();
  if (f.length > 0) {
    writer.writeString(
      4,
      f
    );
  }
  f = message.getSubmenuList();
  if (f.length > 0) {
    writer.writeRepeatedMessage(
      5,
      f,
      proto.xcommon.Menu.serializeBinaryToWriter
    );
  }
};


/**
 * optional int64 Id = 1;
 * @return {number}
 */
proto.xcommon.Menu.prototype.getId = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 1, 0));
};


/**
 * @param {number} value
 * @return {!proto.xcommon.Menu} returns this
 */
proto.xcommon.Menu.prototype.setId = function(value) {
  return jspb.Message.setProto3IntField(this, 1, value);
};


/**
 * optional int64 Pid = 2;
 * @return {number}
 */
proto.xcommon.Menu.prototype.getPid = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 2, 0));
};


/**
 * @param {number} value
 * @return {!proto.xcommon.Menu} returns this
 */
proto.xcommon.Menu.prototype.setPid = function(value) {
  return jspb.Message.setProto3IntField(this, 2, value);
};


/**
 * optional string Name = 3;
 * @return {string}
 */
proto.xcommon.Menu.prototype.getName = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 3, ""));
};


/**
 * @param {string} value
 * @return {!proto.xcommon.Menu} returns this
 */
proto.xcommon.Menu.prototype.setName = function(value) {
  return jspb.Message.setProto3StringField(this, 3, value);
};


/**
 * optional string Route = 4;
 * @return {string}
 */
proto.xcommon.Menu.prototype.getRoute = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 4, ""));
};


/**
 * @param {string} value
 * @return {!proto.xcommon.Menu} returns this
 */
proto.xcommon.Menu.prototype.setRoute = function(value) {
  return jspb.Message.setProto3StringField(this, 4, value);
};


/**
 * repeated Menu SubMenu = 5;
 * @return {!Array<!proto.xcommon.Menu>}
 */
proto.xcommon.Menu.prototype.getSubmenuList = function() {
  return /** @type{!Array<!proto.xcommon.Menu>} */ (
    jspb.Message.getRepeatedWrapperField(this, proto.xcommon.Menu, 5));
};


/**
 * @param {!Array<!proto.xcommon.Menu>} value
 * @return {!proto.xcommon.Menu} returns this
*/
proto.xcommon.Menu.prototype.setSubmenuList = function(value) {
  return jspb.Message.setRepeatedWrapperField(this, 5, value);
};


/**
 * @param {!proto.xcommon.Menu=} opt_value
 * @param {number=} opt_index
 * @return {!proto.xcommon.Menu}
 */
proto.xcommon.Menu.prototype.addSubmenu = function(opt_value, opt_index) {
  return jspb.Message.addToRepeatedWrapperField(this, 5, opt_value, proto.xcommon.Menu, opt_index);
};


/**
 * Clears the list making it empty but non-null.
 * @return {!proto.xcommon.Menu} returns this
 */
proto.xcommon.Menu.prototype.clearSubmenuList = function() {
  return this.setSubmenuList([]);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.xcommon.UserInfo.prototype.toObject = function(opt_includeInstance) {
  return proto.xcommon.UserInfo.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.xcommon.UserInfo} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.xcommon.UserInfo.toObject = function(includeInstance, msg) {
  var f, obj = {
    code: jspb.Message.getFieldWithDefault(msg, 1, 0),
    errmsg: jspb.Message.getFieldWithDefault(msg, 2, ""),
    common: (f = msg.getCommon()) && proto.xcommon.UserCommon.toObject(includeInstance, f),
    id: jspb.Message.getFieldWithDefault(msg, 4, 0),
    employeeid: jspb.Message.getFieldWithDefault(msg, 5, ""),
    mobile: jspb.Message.getFieldWithDefault(msg, 6, ""),
    operatorname: jspb.Message.getFieldWithDefault(msg, 7, ""),
    operatetime: jspb.Message.getFieldWithDefault(msg, 8, 0),
    issuperadmin: jspb.Message.getBooleanFieldWithDefault(msg, 9, false),
    attendanceat: jspb.Message.getFieldWithDefault(msg, 10, 0),
    registertime: jspb.Message.getFieldWithDefault(msg, 11, 0),
    lastlogintime: jspb.Message.getFieldWithDefault(msg, 12, 0),
    workstatus: jspb.Message.getFieldWithDefault(msg, 13, 0),
    archiveid: jspb.Message.getFieldWithDefault(msg, 15, 0),
    loginstatus: jspb.Message.getFieldWithDefault(msg, 16, 0),
    loadnum: jspb.Message.getFieldWithDefault(msg, 17, 0)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.xcommon.UserInfo}
 */
proto.xcommon.UserInfo.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.xcommon.UserInfo;
  return proto.xcommon.UserInfo.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.xcommon.UserInfo} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.xcommon.UserInfo}
 */
proto.xcommon.UserInfo.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {number} */ (reader.readInt32());
      msg.setCode(value);
      break;
    case 2:
      var value = /** @type {string} */ (reader.readString());
      msg.setErrmsg(value);
      break;
    case 3:
      var value = new proto.xcommon.UserCommon;
      reader.readMessage(value,proto.xcommon.UserCommon.deserializeBinaryFromReader);
      msg.setCommon(value);
      break;
    case 4:
      var value = /** @type {number} */ (reader.readInt64());
      msg.setId(value);
      break;
    case 5:
      var value = /** @type {string} */ (reader.readString());
      msg.setEmployeeid(value);
      break;
    case 6:
      var value = /** @type {string} */ (reader.readString());
      msg.setMobile(value);
      break;
    case 7:
      var value = /** @type {string} */ (reader.readString());
      msg.setOperatorname(value);
      break;
    case 8:
      var value = /** @type {number} */ (reader.readInt64());
      msg.setOperatetime(value);
      break;
    case 9:
      var value = /** @type {boolean} */ (reader.readBool());
      msg.setIssuperadmin(value);
      break;
    case 10:
      var value = /** @type {number} */ (reader.readInt64());
      msg.setAttendanceat(value);
      break;
    case 11:
      var value = /** @type {number} */ (reader.readInt64());
      msg.setRegistertime(value);
      break;
    case 12:
      var value = /** @type {number} */ (reader.readInt64());
      msg.setLastlogintime(value);
      break;
    case 13:
      var value = /** @type {!proto.xcommon.UserWorkStatus} */ (reader.readEnum());
      msg.setWorkstatus(value);
      break;
    case 15:
      var value = /** @type {number} */ (reader.readInt64());
      msg.setArchiveid(value);
      break;
    case 16:
      var value = /** @type {!proto.xcommon.LoginStatus} */ (reader.readEnum());
      msg.setLoginstatus(value);
      break;
    case 17:
      var value = /** @type {number} */ (reader.readInt64());
      msg.setLoadnum(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.xcommon.UserInfo.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.xcommon.UserInfo.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.xcommon.UserInfo} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.xcommon.UserInfo.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getCode();
  if (f !== 0) {
    writer.writeInt32(
      1,
      f
    );
  }
  f = message.getErrmsg();
  if (f.length > 0) {
    writer.writeString(
      2,
      f
    );
  }
  f = message.getCommon();
  if (f != null) {
    writer.writeMessage(
      3,
      f,
      proto.xcommon.UserCommon.serializeBinaryToWriter
    );
  }
  f = message.getId();
  if (f !== 0) {
    writer.writeInt64(
      4,
      f
    );
  }
  f = message.getEmployeeid();
  if (f.length > 0) {
    writer.writeString(
      5,
      f
    );
  }
  f = message.getMobile();
  if (f.length > 0) {
    writer.writeString(
      6,
      f
    );
  }
  f = message.getOperatorname();
  if (f.length > 0) {
    writer.writeString(
      7,
      f
    );
  }
  f = message.getOperatetime();
  if (f !== 0) {
    writer.writeInt64(
      8,
      f
    );
  }
  f = message.getIssuperadmin();
  if (f) {
    writer.writeBool(
      9,
      f
    );
  }
  f = message.getAttendanceat();
  if (f !== 0) {
    writer.writeInt64(
      10,
      f
    );
  }
  f = message.getRegistertime();
  if (f !== 0) {
    writer.writeInt64(
      11,
      f
    );
  }
  f = message.getLastlogintime();
  if (f !== 0) {
    writer.writeInt64(
      12,
      f
    );
  }
  f = message.getWorkstatus();
  if (f !== 0.0) {
    writer.writeEnum(
      13,
      f
    );
  }
  f = message.getArchiveid();
  if (f !== 0) {
    writer.writeInt64(
      15,
      f
    );
  }
  f = message.getLoginstatus();
  if (f !== 0.0) {
    writer.writeEnum(
      16,
      f
    );
  }
  f = message.getLoadnum();
  if (f !== 0) {
    writer.writeInt64(
      17,
      f
    );
  }
};


/**
 * optional int32 Code = 1;
 * @return {number}
 */
proto.xcommon.UserInfo.prototype.getCode = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 1, 0));
};


/**
 * @param {number} value
 * @return {!proto.xcommon.UserInfo} returns this
 */
proto.xcommon.UserInfo.prototype.setCode = function(value) {
  return jspb.Message.setProto3IntField(this, 1, value);
};


/**
 * optional string ErrMsg = 2;
 * @return {string}
 */
proto.xcommon.UserInfo.prototype.getErrmsg = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 2, ""));
};


/**
 * @param {string} value
 * @return {!proto.xcommon.UserInfo} returns this
 */
proto.xcommon.UserInfo.prototype.setErrmsg = function(value) {
  return jspb.Message.setProto3StringField(this, 2, value);
};


/**
 * optional UserCommon Common = 3;
 * @return {?proto.xcommon.UserCommon}
 */
proto.xcommon.UserInfo.prototype.getCommon = function() {
  return /** @type{?proto.xcommon.UserCommon} */ (
    jspb.Message.getWrapperField(this, proto.xcommon.UserCommon, 3));
};


/**
 * @param {?proto.xcommon.UserCommon|undefined} value
 * @return {!proto.xcommon.UserInfo} returns this
*/
proto.xcommon.UserInfo.prototype.setCommon = function(value) {
  return jspb.Message.setWrapperField(this, 3, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.xcommon.UserInfo} returns this
 */
proto.xcommon.UserInfo.prototype.clearCommon = function() {
  return this.setCommon(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.xcommon.UserInfo.prototype.hasCommon = function() {
  return jspb.Message.getField(this, 3) != null;
};


/**
 * optional int64 Id = 4;
 * @return {number}
 */
proto.xcommon.UserInfo.prototype.getId = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 4, 0));
};


/**
 * @param {number} value
 * @return {!proto.xcommon.UserInfo} returns this
 */
proto.xcommon.UserInfo.prototype.setId = function(value) {
  return jspb.Message.setProto3IntField(this, 4, value);
};


/**
 * optional string EmployeeId = 5;
 * @return {string}
 */
proto.xcommon.UserInfo.prototype.getEmployeeid = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 5, ""));
};


/**
 * @param {string} value
 * @return {!proto.xcommon.UserInfo} returns this
 */
proto.xcommon.UserInfo.prototype.setEmployeeid = function(value) {
  return jspb.Message.setProto3StringField(this, 5, value);
};


/**
 * optional string Mobile = 6;
 * @return {string}
 */
proto.xcommon.UserInfo.prototype.getMobile = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 6, ""));
};


/**
 * @param {string} value
 * @return {!proto.xcommon.UserInfo} returns this
 */
proto.xcommon.UserInfo.prototype.setMobile = function(value) {
  return jspb.Message.setProto3StringField(this, 6, value);
};


/**
 * optional string OperatorName = 7;
 * @return {string}
 */
proto.xcommon.UserInfo.prototype.getOperatorname = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 7, ""));
};


/**
 * @param {string} value
 * @return {!proto.xcommon.UserInfo} returns this
 */
proto.xcommon.UserInfo.prototype.setOperatorname = function(value) {
  return jspb.Message.setProto3StringField(this, 7, value);
};


/**
 * optional int64 OperateTime = 8;
 * @return {number}
 */
proto.xcommon.UserInfo.prototype.getOperatetime = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 8, 0));
};


/**
 * @param {number} value
 * @return {!proto.xcommon.UserInfo} returns this
 */
proto.xcommon.UserInfo.prototype.setOperatetime = function(value) {
  return jspb.Message.setProto3IntField(this, 8, value);
};


/**
 * optional bool IsSuperAdmin = 9;
 * @return {boolean}
 */
proto.xcommon.UserInfo.prototype.getIssuperadmin = function() {
  return /** @type {boolean} */ (jspb.Message.getBooleanFieldWithDefault(this, 9, false));
};


/**
 * @param {boolean} value
 * @return {!proto.xcommon.UserInfo} returns this
 */
proto.xcommon.UserInfo.prototype.setIssuperadmin = function(value) {
  return jspb.Message.setProto3BooleanField(this, 9, value);
};


/**
 * optional int64 AttendanceAt = 10;
 * @return {number}
 */
proto.xcommon.UserInfo.prototype.getAttendanceat = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 10, 0));
};


/**
 * @param {number} value
 * @return {!proto.xcommon.UserInfo} returns this
 */
proto.xcommon.UserInfo.prototype.setAttendanceat = function(value) {
  return jspb.Message.setProto3IntField(this, 10, value);
};


/**
 * optional int64 RegisterTime = 11;
 * @return {number}
 */
proto.xcommon.UserInfo.prototype.getRegistertime = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 11, 0));
};


/**
 * @param {number} value
 * @return {!proto.xcommon.UserInfo} returns this
 */
proto.xcommon.UserInfo.prototype.setRegistertime = function(value) {
  return jspb.Message.setProto3IntField(this, 11, value);
};


/**
 * optional int64 LastLoginTime = 12;
 * @return {number}
 */
proto.xcommon.UserInfo.prototype.getLastlogintime = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 12, 0));
};


/**
 * @param {number} value
 * @return {!proto.xcommon.UserInfo} returns this
 */
proto.xcommon.UserInfo.prototype.setLastlogintime = function(value) {
  return jspb.Message.setProto3IntField(this, 12, value);
};


/**
 * optional UserWorkStatus WorkStatus = 13;
 * @return {!proto.xcommon.UserWorkStatus}
 */
proto.xcommon.UserInfo.prototype.getWorkstatus = function() {
  return /** @type {!proto.xcommon.UserWorkStatus} */ (jspb.Message.getFieldWithDefault(this, 13, 0));
};


/**
 * @param {!proto.xcommon.UserWorkStatus} value
 * @return {!proto.xcommon.UserInfo} returns this
 */
proto.xcommon.UserInfo.prototype.setWorkstatus = function(value) {
  return jspb.Message.setProto3EnumField(this, 13, value);
};


/**
 * optional int64 ArchiveID = 15;
 * @return {number}
 */
proto.xcommon.UserInfo.prototype.getArchiveid = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 15, 0));
};


/**
 * @param {number} value
 * @return {!proto.xcommon.UserInfo} returns this
 */
proto.xcommon.UserInfo.prototype.setArchiveid = function(value) {
  return jspb.Message.setProto3IntField(this, 15, value);
};


/**
 * optional LoginStatus LoginStatus = 16;
 * @return {!proto.xcommon.LoginStatus}
 */
proto.xcommon.UserInfo.prototype.getLoginstatus = function() {
  return /** @type {!proto.xcommon.LoginStatus} */ (jspb.Message.getFieldWithDefault(this, 16, 0));
};


/**
 * @param {!proto.xcommon.LoginStatus} value
 * @return {!proto.xcommon.UserInfo} returns this
 */
proto.xcommon.UserInfo.prototype.setLoginstatus = function(value) {
  return jspb.Message.setProto3EnumField(this, 16, value);
};


/**
 * optional int64 LoadNum = 17;
 * @return {number}
 */
proto.xcommon.UserInfo.prototype.getLoadnum = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 17, 0));
};


/**
 * @param {number} value
 * @return {!proto.xcommon.UserInfo} returns this
 */
proto.xcommon.UserInfo.prototype.setLoadnum = function(value) {
  return jspb.Message.setProto3IntField(this, 17, value);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.xcommon.UserInfoMini.prototype.toObject = function(opt_includeInstance) {
  return proto.xcommon.UserInfoMini.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.xcommon.UserInfoMini} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.xcommon.UserInfoMini.toObject = function(includeInstance, msg) {
  var f, obj = {
    code: jspb.Message.getFieldWithDefault(msg, 1, 0),
    errmsg: jspb.Message.getFieldWithDefault(msg, 2, ""),
    email: jspb.Message.getFieldWithDefault(msg, 3, ""),
    id: jspb.Message.getFieldWithDefault(msg, 4, 0),
    employeeid: jspb.Message.getFieldWithDefault(msg, 5, ""),
    mobile: jspb.Message.getFieldWithDefault(msg, 6, ""),
    name: jspb.Message.getFieldWithDefault(msg, 7, "")
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.xcommon.UserInfoMini}
 */
proto.xcommon.UserInfoMini.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.xcommon.UserInfoMini;
  return proto.xcommon.UserInfoMini.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.xcommon.UserInfoMini} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.xcommon.UserInfoMini}
 */
proto.xcommon.UserInfoMini.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {number} */ (reader.readInt32());
      msg.setCode(value);
      break;
    case 2:
      var value = /** @type {string} */ (reader.readString());
      msg.setErrmsg(value);
      break;
    case 3:
      var value = /** @type {string} */ (reader.readString());
      msg.setEmail(value);
      break;
    case 4:
      var value = /** @type {number} */ (reader.readInt64());
      msg.setId(value);
      break;
    case 5:
      var value = /** @type {string} */ (reader.readString());
      msg.setEmployeeid(value);
      break;
    case 6:
      var value = /** @type {string} */ (reader.readString());
      msg.setMobile(value);
      break;
    case 7:
      var value = /** @type {string} */ (reader.readString());
      msg.setName(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.xcommon.UserInfoMini.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.xcommon.UserInfoMini.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.xcommon.UserInfoMini} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.xcommon.UserInfoMini.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getCode();
  if (f !== 0) {
    writer.writeInt32(
      1,
      f
    );
  }
  f = message.getErrmsg();
  if (f.length > 0) {
    writer.writeString(
      2,
      f
    );
  }
  f = message.getEmail();
  if (f.length > 0) {
    writer.writeString(
      3,
      f
    );
  }
  f = message.getId();
  if (f !== 0) {
    writer.writeInt64(
      4,
      f
    );
  }
  f = message.getEmployeeid();
  if (f.length > 0) {
    writer.writeString(
      5,
      f
    );
  }
  f = message.getMobile();
  if (f.length > 0) {
    writer.writeString(
      6,
      f
    );
  }
  f = message.getName();
  if (f.length > 0) {
    writer.writeString(
      7,
      f
    );
  }
};


/**
 * optional int32 Code = 1;
 * @return {number}
 */
proto.xcommon.UserInfoMini.prototype.getCode = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 1, 0));
};


/**
 * @param {number} value
 * @return {!proto.xcommon.UserInfoMini} returns this
 */
proto.xcommon.UserInfoMini.prototype.setCode = function(value) {
  return jspb.Message.setProto3IntField(this, 1, value);
};


/**
 * optional string ErrMsg = 2;
 * @return {string}
 */
proto.xcommon.UserInfoMini.prototype.getErrmsg = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 2, ""));
};


/**
 * @param {string} value
 * @return {!proto.xcommon.UserInfoMini} returns this
 */
proto.xcommon.UserInfoMini.prototype.setErrmsg = function(value) {
  return jspb.Message.setProto3StringField(this, 2, value);
};


/**
 * optional string Email = 3;
 * @return {string}
 */
proto.xcommon.UserInfoMini.prototype.getEmail = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 3, ""));
};


/**
 * @param {string} value
 * @return {!proto.xcommon.UserInfoMini} returns this
 */
proto.xcommon.UserInfoMini.prototype.setEmail = function(value) {
  return jspb.Message.setProto3StringField(this, 3, value);
};


/**
 * optional int64 Id = 4;
 * @return {number}
 */
proto.xcommon.UserInfoMini.prototype.getId = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 4, 0));
};


/**
 * @param {number} value
 * @return {!proto.xcommon.UserInfoMini} returns this
 */
proto.xcommon.UserInfoMini.prototype.setId = function(value) {
  return jspb.Message.setProto3IntField(this, 4, value);
};


/**
 * optional string EmployeeId = 5;
 * @return {string}
 */
proto.xcommon.UserInfoMini.prototype.getEmployeeid = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 5, ""));
};


/**
 * @param {string} value
 * @return {!proto.xcommon.UserInfoMini} returns this
 */
proto.xcommon.UserInfoMini.prototype.setEmployeeid = function(value) {
  return jspb.Message.setProto3StringField(this, 5, value);
};


/**
 * optional string Mobile = 6;
 * @return {string}
 */
proto.xcommon.UserInfoMini.prototype.getMobile = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 6, ""));
};


/**
 * @param {string} value
 * @return {!proto.xcommon.UserInfoMini} returns this
 */
proto.xcommon.UserInfoMini.prototype.setMobile = function(value) {
  return jspb.Message.setProto3StringField(this, 6, value);
};


/**
 * optional string Name = 7;
 * @return {string}
 */
proto.xcommon.UserInfoMini.prototype.getName = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 7, ""));
};


/**
 * @param {string} value
 * @return {!proto.xcommon.UserInfoMini} returns this
 */
proto.xcommon.UserInfoMini.prototype.setName = function(value) {
  return jspb.Message.setProto3StringField(this, 7, value);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.xcommon.UserCommon.prototype.toObject = function(opt_includeInstance) {
  return proto.xcommon.UserCommon.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.xcommon.UserCommon} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.xcommon.UserCommon.toObject = function(includeInstance, msg) {
  var f, obj = {
    email: jspb.Message.getFieldWithDefault(msg, 1, ""),
    name: jspb.Message.getFieldWithDefault(msg, 2, ""),
    usergroup: jspb.Message.getFieldWithDefault(msg, 3, ""),
    secondaryverify: jspb.Message.getBooleanFieldWithDefault(msg, 4, false),
    exectype: jspb.Message.getFieldWithDefault(msg, 5, 0),
    company: (f = msg.getCompany()) && xcommon_module_pb.Meta.toObject(includeInstance, f),
    status: jspb.Message.getFieldWithDefault(msg, 7, 0)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.xcommon.UserCommon}
 */
proto.xcommon.UserCommon.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.xcommon.UserCommon;
  return proto.xcommon.UserCommon.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.xcommon.UserCommon} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.xcommon.UserCommon}
 */
proto.xcommon.UserCommon.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {string} */ (reader.readString());
      msg.setEmail(value);
      break;
    case 2:
      var value = /** @type {string} */ (reader.readString());
      msg.setName(value);
      break;
    case 3:
      var value = /** @type {string} */ (reader.readString());
      msg.setUsergroup(value);
      break;
    case 4:
      var value = /** @type {boolean} */ (reader.readBool());
      msg.setSecondaryverify(value);
      break;
    case 5:
      var value = /** @type {!proto.xcommon.ExecType} */ (reader.readEnum());
      msg.setExectype(value);
      break;
    case 6:
      var value = new xcommon_module_pb.Meta;
      reader.readMessage(value,xcommon_module_pb.Meta.deserializeBinaryFromReader);
      msg.setCompany(value);
      break;
    case 7:
      var value = /** @type {!proto.xcommon.UserStatus} */ (reader.readEnum());
      msg.setStatus(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.xcommon.UserCommon.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.xcommon.UserCommon.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.xcommon.UserCommon} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.xcommon.UserCommon.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getEmail();
  if (f.length > 0) {
    writer.writeString(
      1,
      f
    );
  }
  f = message.getName();
  if (f.length > 0) {
    writer.writeString(
      2,
      f
    );
  }
  f = message.getUsergroup();
  if (f.length > 0) {
    writer.writeString(
      3,
      f
    );
  }
  f = message.getSecondaryverify();
  if (f) {
    writer.writeBool(
      4,
      f
    );
  }
  f = message.getExectype();
  if (f !== 0.0) {
    writer.writeEnum(
      5,
      f
    );
  }
  f = message.getCompany();
  if (f != null) {
    writer.writeMessage(
      6,
      f,
      xcommon_module_pb.Meta.serializeBinaryToWriter
    );
  }
  f = message.getStatus();
  if (f !== 0.0) {
    writer.writeEnum(
      7,
      f
    );
  }
};


/**
 * optional string Email = 1;
 * @return {string}
 */
proto.xcommon.UserCommon.prototype.getEmail = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 1, ""));
};


/**
 * @param {string} value
 * @return {!proto.xcommon.UserCommon} returns this
 */
proto.xcommon.UserCommon.prototype.setEmail = function(value) {
  return jspb.Message.setProto3StringField(this, 1, value);
};


/**
 * optional string Name = 2;
 * @return {string}
 */
proto.xcommon.UserCommon.prototype.getName = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 2, ""));
};


/**
 * @param {string} value
 * @return {!proto.xcommon.UserCommon} returns this
 */
proto.xcommon.UserCommon.prototype.setName = function(value) {
  return jspb.Message.setProto3StringField(this, 2, value);
};


/**
 * optional string UserGroup = 3;
 * @return {string}
 */
proto.xcommon.UserCommon.prototype.getUsergroup = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 3, ""));
};


/**
 * @param {string} value
 * @return {!proto.xcommon.UserCommon} returns this
 */
proto.xcommon.UserCommon.prototype.setUsergroup = function(value) {
  return jspb.Message.setProto3StringField(this, 3, value);
};


/**
 * optional bool SecondaryVerify = 4;
 * @return {boolean}
 */
proto.xcommon.UserCommon.prototype.getSecondaryverify = function() {
  return /** @type {boolean} */ (jspb.Message.getBooleanFieldWithDefault(this, 4, false));
};


/**
 * @param {boolean} value
 * @return {!proto.xcommon.UserCommon} returns this
 */
proto.xcommon.UserCommon.prototype.setSecondaryverify = function(value) {
  return jspb.Message.setProto3BooleanField(this, 4, value);
};


/**
 * optional ExecType ExecType = 5;
 * @return {!proto.xcommon.ExecType}
 */
proto.xcommon.UserCommon.prototype.getExectype = function() {
  return /** @type {!proto.xcommon.ExecType} */ (jspb.Message.getFieldWithDefault(this, 5, 0));
};


/**
 * @param {!proto.xcommon.ExecType} value
 * @return {!proto.xcommon.UserCommon} returns this
 */
proto.xcommon.UserCommon.prototype.setExectype = function(value) {
  return jspb.Message.setProto3EnumField(this, 5, value);
};


/**
 * optional Meta Company = 6;
 * @return {?proto.xcommon.Meta}
 */
proto.xcommon.UserCommon.prototype.getCompany = function() {
  return /** @type{?proto.xcommon.Meta} */ (
    jspb.Message.getWrapperField(this, xcommon_module_pb.Meta, 6));
};


/**
 * @param {?proto.xcommon.Meta|undefined} value
 * @return {!proto.xcommon.UserCommon} returns this
*/
proto.xcommon.UserCommon.prototype.setCompany = function(value) {
  return jspb.Message.setWrapperField(this, 6, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.xcommon.UserCommon} returns this
 */
proto.xcommon.UserCommon.prototype.clearCompany = function() {
  return this.setCompany(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.xcommon.UserCommon.prototype.hasCompany = function() {
  return jspb.Message.getField(this, 6) != null;
};


/**
 * optional UserStatus Status = 7;
 * @return {!proto.xcommon.UserStatus}
 */
proto.xcommon.UserCommon.prototype.getStatus = function() {
  return /** @type {!proto.xcommon.UserStatus} */ (jspb.Message.getFieldWithDefault(this, 7, 0));
};


/**
 * @param {!proto.xcommon.UserStatus} value
 * @return {!proto.xcommon.UserCommon} returns this
 */
proto.xcommon.UserCommon.prototype.setStatus = function(value) {
  return jspb.Message.setProto3EnumField(this, 7, value);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.xcommon.LoginInfo.prototype.toObject = function(opt_includeInstance) {
  return proto.xcommon.LoginInfo.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.xcommon.LoginInfo} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.xcommon.LoginInfo.toObject = function(includeInstance, msg) {
  var f, obj = {
    status: jspb.Message.getFieldWithDefault(msg, 1, 0),
    lastlogintime: jspb.Message.getFieldWithDefault(msg, 2, 0),
    firstlogintime: jspb.Message.getFieldWithDefault(msg, 3, 0),
    logincount: jspb.Message.getFieldWithDefault(msg, 4, 0)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.xcommon.LoginInfo}
 */
proto.xcommon.LoginInfo.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.xcommon.LoginInfo;
  return proto.xcommon.LoginInfo.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.xcommon.LoginInfo} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.xcommon.LoginInfo}
 */
proto.xcommon.LoginInfo.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {!proto.xcommon.LoginStatus} */ (reader.readEnum());
      msg.setStatus(value);
      break;
    case 2:
      var value = /** @type {number} */ (reader.readInt64());
      msg.setLastlogintime(value);
      break;
    case 3:
      var value = /** @type {number} */ (reader.readInt64());
      msg.setFirstlogintime(value);
      break;
    case 4:
      var value = /** @type {number} */ (reader.readInt64());
      msg.setLogincount(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.xcommon.LoginInfo.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.xcommon.LoginInfo.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.xcommon.LoginInfo} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.xcommon.LoginInfo.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getStatus();
  if (f !== 0.0) {
    writer.writeEnum(
      1,
      f
    );
  }
  f = message.getLastlogintime();
  if (f !== 0) {
    writer.writeInt64(
      2,
      f
    );
  }
  f = message.getFirstlogintime();
  if (f !== 0) {
    writer.writeInt64(
      3,
      f
    );
  }
  f = message.getLogincount();
  if (f !== 0) {
    writer.writeInt64(
      4,
      f
    );
  }
};


/**
 * optional LoginStatus Status = 1;
 * @return {!proto.xcommon.LoginStatus}
 */
proto.xcommon.LoginInfo.prototype.getStatus = function() {
  return /** @type {!proto.xcommon.LoginStatus} */ (jspb.Message.getFieldWithDefault(this, 1, 0));
};


/**
 * @param {!proto.xcommon.LoginStatus} value
 * @return {!proto.xcommon.LoginInfo} returns this
 */
proto.xcommon.LoginInfo.prototype.setStatus = function(value) {
  return jspb.Message.setProto3EnumField(this, 1, value);
};


/**
 * optional int64 LastLoginTime = 2;
 * @return {number}
 */
proto.xcommon.LoginInfo.prototype.getLastlogintime = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 2, 0));
};


/**
 * @param {number} value
 * @return {!proto.xcommon.LoginInfo} returns this
 */
proto.xcommon.LoginInfo.prototype.setLastlogintime = function(value) {
  return jspb.Message.setProto3IntField(this, 2, value);
};


/**
 * optional int64 FirstLoginTime = 3;
 * @return {number}
 */
proto.xcommon.LoginInfo.prototype.getFirstlogintime = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 3, 0));
};


/**
 * @param {number} value
 * @return {!proto.xcommon.LoginInfo} returns this
 */
proto.xcommon.LoginInfo.prototype.setFirstlogintime = function(value) {
  return jspb.Message.setProto3IntField(this, 3, value);
};


/**
 * optional int64 LoginCount = 4;
 * @return {number}
 */
proto.xcommon.LoginInfo.prototype.getLogincount = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 4, 0));
};


/**
 * @param {number} value
 * @return {!proto.xcommon.LoginInfo} returns this
 */
proto.xcommon.LoginInfo.prototype.setLogincount = function(value) {
  return jspb.Message.setProto3IntField(this, 4, value);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.xcommon.CaptchaReq.prototype.toObject = function(opt_includeInstance) {
  return proto.xcommon.CaptchaReq.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.xcommon.CaptchaReq} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.xcommon.CaptchaReq.toObject = function(includeInstance, msg) {
  var f, obj = {
    trackid: jspb.Message.getFieldWithDefault(msg, 1, ""),
    clientid: jspb.Message.getFieldWithDefault(msg, 2, ""),
    width: jspb.Message.getFieldWithDefault(msg, 3, 0),
    height: jspb.Message.getFieldWithDefault(msg, 4, 0),
    length: jspb.Message.getFieldWithDefault(msg, 5, 0),
    email: jspb.Message.getFieldWithDefault(msg, 6, "")
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.xcommon.CaptchaReq}
 */
proto.xcommon.CaptchaReq.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.xcommon.CaptchaReq;
  return proto.xcommon.CaptchaReq.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.xcommon.CaptchaReq} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.xcommon.CaptchaReq}
 */
proto.xcommon.CaptchaReq.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {string} */ (reader.readString());
      msg.setTrackid(value);
      break;
    case 2:
      var value = /** @type {string} */ (reader.readString());
      msg.setClientid(value);
      break;
    case 3:
      var value = /** @type {number} */ (reader.readInt32());
      msg.setWidth(value);
      break;
    case 4:
      var value = /** @type {number} */ (reader.readInt32());
      msg.setHeight(value);
      break;
    case 5:
      var value = /** @type {number} */ (reader.readInt32());
      msg.setLength(value);
      break;
    case 6:
      var value = /** @type {string} */ (reader.readString());
      msg.setEmail(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.xcommon.CaptchaReq.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.xcommon.CaptchaReq.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.xcommon.CaptchaReq} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.xcommon.CaptchaReq.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getTrackid();
  if (f.length > 0) {
    writer.writeString(
      1,
      f
    );
  }
  f = message.getClientid();
  if (f.length > 0) {
    writer.writeString(
      2,
      f
    );
  }
  f = message.getWidth();
  if (f !== 0) {
    writer.writeInt32(
      3,
      f
    );
  }
  f = message.getHeight();
  if (f !== 0) {
    writer.writeInt32(
      4,
      f
    );
  }
  f = message.getLength();
  if (f !== 0) {
    writer.writeInt32(
      5,
      f
    );
  }
  f = message.getEmail();
  if (f.length > 0) {
    writer.writeString(
      6,
      f
    );
  }
};


/**
 * optional string TrackId = 1;
 * @return {string}
 */
proto.xcommon.CaptchaReq.prototype.getTrackid = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 1, ""));
};


/**
 * @param {string} value
 * @return {!proto.xcommon.CaptchaReq} returns this
 */
proto.xcommon.CaptchaReq.prototype.setTrackid = function(value) {
  return jspb.Message.setProto3StringField(this, 1, value);
};


/**
 * optional string ClientId = 2;
 * @return {string}
 */
proto.xcommon.CaptchaReq.prototype.getClientid = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 2, ""));
};


/**
 * @param {string} value
 * @return {!proto.xcommon.CaptchaReq} returns this
 */
proto.xcommon.CaptchaReq.prototype.setClientid = function(value) {
  return jspb.Message.setProto3StringField(this, 2, value);
};


/**
 * optional int32 Width = 3;
 * @return {number}
 */
proto.xcommon.CaptchaReq.prototype.getWidth = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 3, 0));
};


/**
 * @param {number} value
 * @return {!proto.xcommon.CaptchaReq} returns this
 */
proto.xcommon.CaptchaReq.prototype.setWidth = function(value) {
  return jspb.Message.setProto3IntField(this, 3, value);
};


/**
 * optional int32 Height = 4;
 * @return {number}
 */
proto.xcommon.CaptchaReq.prototype.getHeight = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 4, 0));
};


/**
 * @param {number} value
 * @return {!proto.xcommon.CaptchaReq} returns this
 */
proto.xcommon.CaptchaReq.prototype.setHeight = function(value) {
  return jspb.Message.setProto3IntField(this, 4, value);
};


/**
 * optional int32 Length = 5;
 * @return {number}
 */
proto.xcommon.CaptchaReq.prototype.getLength = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 5, 0));
};


/**
 * @param {number} value
 * @return {!proto.xcommon.CaptchaReq} returns this
 */
proto.xcommon.CaptchaReq.prototype.setLength = function(value) {
  return jspb.Message.setProto3IntField(this, 5, value);
};


/**
 * optional string Email = 6;
 * @return {string}
 */
proto.xcommon.CaptchaReq.prototype.getEmail = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 6, ""));
};


/**
 * @param {string} value
 * @return {!proto.xcommon.CaptchaReq} returns this
 */
proto.xcommon.CaptchaReq.prototype.setEmail = function(value) {
  return jspb.Message.setProto3StringField(this, 6, value);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.xcommon.CaptchaResp.prototype.toObject = function(opt_includeInstance) {
  return proto.xcommon.CaptchaResp.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.xcommon.CaptchaResp} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.xcommon.CaptchaResp.toObject = function(includeInstance, msg) {
  var f, obj = {
    commonout: (f = msg.getCommonout()) && xcommon_common_pb.CommonOut.toObject(includeInstance, f),
    showcaptcha: jspb.Message.getFieldWithDefault(msg, 2, 0),
    captchaid: jspb.Message.getFieldWithDefault(msg, 3, ""),
    captcha: jspb.Message.getFieldWithDefault(msg, 4, "")
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.xcommon.CaptchaResp}
 */
proto.xcommon.CaptchaResp.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.xcommon.CaptchaResp;
  return proto.xcommon.CaptchaResp.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.xcommon.CaptchaResp} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.xcommon.CaptchaResp}
 */
proto.xcommon.CaptchaResp.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = new xcommon_common_pb.CommonOut;
      reader.readMessage(value,xcommon_common_pb.CommonOut.deserializeBinaryFromReader);
      msg.setCommonout(value);
      break;
    case 2:
      var value = /** @type {!proto.xcommon.Bool} */ (reader.readEnum());
      msg.setShowcaptcha(value);
      break;
    case 3:
      var value = /** @type {string} */ (reader.readString());
      msg.setCaptchaid(value);
      break;
    case 4:
      var value = /** @type {string} */ (reader.readString());
      msg.setCaptcha(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.xcommon.CaptchaResp.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.xcommon.CaptchaResp.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.xcommon.CaptchaResp} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.xcommon.CaptchaResp.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getCommonout();
  if (f != null) {
    writer.writeMessage(
      1,
      f,
      xcommon_common_pb.CommonOut.serializeBinaryToWriter
    );
  }
  f = message.getShowcaptcha();
  if (f !== 0.0) {
    writer.writeEnum(
      2,
      f
    );
  }
  f = message.getCaptchaid();
  if (f.length > 0) {
    writer.writeString(
      3,
      f
    );
  }
  f = message.getCaptcha();
  if (f.length > 0) {
    writer.writeString(
      4,
      f
    );
  }
};


/**
 * optional CommonOut CommonOut = 1;
 * @return {?proto.xcommon.CommonOut}
 */
proto.xcommon.CaptchaResp.prototype.getCommonout = function() {
  return /** @type{?proto.xcommon.CommonOut} */ (
    jspb.Message.getWrapperField(this, xcommon_common_pb.CommonOut, 1));
};


/**
 * @param {?proto.xcommon.CommonOut|undefined} value
 * @return {!proto.xcommon.CaptchaResp} returns this
*/
proto.xcommon.CaptchaResp.prototype.setCommonout = function(value) {
  return jspb.Message.setWrapperField(this, 1, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.xcommon.CaptchaResp} returns this
 */
proto.xcommon.CaptchaResp.prototype.clearCommonout = function() {
  return this.setCommonout(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.xcommon.CaptchaResp.prototype.hasCommonout = function() {
  return jspb.Message.getField(this, 1) != null;
};


/**
 * optional Bool ShowCaptcha = 2;
 * @return {!proto.xcommon.Bool}
 */
proto.xcommon.CaptchaResp.prototype.getShowcaptcha = function() {
  return /** @type {!proto.xcommon.Bool} */ (jspb.Message.getFieldWithDefault(this, 2, 0));
};


/**
 * @param {!proto.xcommon.Bool} value
 * @return {!proto.xcommon.CaptchaResp} returns this
 */
proto.xcommon.CaptchaResp.prototype.setShowcaptcha = function(value) {
  return jspb.Message.setProto3EnumField(this, 2, value);
};


/**
 * optional string CaptchaId = 3;
 * @return {string}
 */
proto.xcommon.CaptchaResp.prototype.getCaptchaid = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 3, ""));
};


/**
 * @param {string} value
 * @return {!proto.xcommon.CaptchaResp} returns this
 */
proto.xcommon.CaptchaResp.prototype.setCaptchaid = function(value) {
  return jspb.Message.setProto3StringField(this, 3, value);
};


/**
 * optional string Captcha = 4;
 * @return {string}
 */
proto.xcommon.CaptchaResp.prototype.getCaptcha = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 4, ""));
};


/**
 * @param {string} value
 * @return {!proto.xcommon.CaptchaResp} returns this
 */
proto.xcommon.CaptchaResp.prototype.setCaptcha = function(value) {
  return jspb.Message.setProto3StringField(this, 4, value);
};


module.exports = proto.xcommon;
